import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import * as R from 'ramda';

import { hasValue } from '../util';
import { FeatureGuide } from './feature-guide';
import { FeatureGuideService } from './feature-guide.service';
import { FeatureGuideElement } from './feature-guide-element';
import { FeatureGuideTooltipService } from './feature-guide-tooltip.service';

@Directive({
  selector: '[pcsFeatureGuides]'
})
export class FeatureGuidesDirective implements OnInit, OnDestroy {
  @Input() pcsFeatureGuides: FeatureGuide[] = [];

  private featureGuideElements: FeatureGuideElement[];

  constructor(
    private readonly element: ElementRef,
    private readonly renderer: Renderer2,
    private readonly featureGuideTooltipService: FeatureGuideTooltipService,
    private readonly featureGuideService: FeatureGuideService
  ) {
  }

  ngOnInit() {
    this.setFeatureGuideElements();
    if (hasValue(this.featureGuideElements)) {
      this.featureGuideElements.forEach(guide => this.featureGuideService.register(guide));
    }
  }

  ngOnDestroy() {
    if (hasValue(this.featureGuideElements)) {
      this.featureGuideElements.forEach(guide => this.featureGuideService.unregister(guide));
    }
  }

  private setFeatureGuideElements() {
    const validFeatureGuides = R.filter(R.compose(hasValue, R.prop('id')), this.pcsFeatureGuides);
    this.featureGuideElements = R.map(guide => new FeatureGuideElement(guide as FeatureGuide,
      this.element,
      this.renderer,
      this.featureGuideTooltipService
    ), validFeatureGuides);
  }
}
